module.exports = __webpack_public_path__ + "img/113.7.77893d6f.png";